// ImageWithSkeleton.js
import React, { useState, useEffect, Fragment, useRef } from 'react';
import styled from 'styled-components';
import previewImage from '../../../../assets/images/dummyImage.jpg'
import SingleImageModal from './SingleImageModal';

const WraperDiv = styled.div`
  position: relative;
  width: 100%;
  padding-top: 100%;
  border-radius: 14px 14px 0 0;
  overflow: hidden;
  background: #f3f4f6;
`

const PreviewImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  object-fit: cover;
  display: block;
`

const WatermarkOverlay = styled.img`
  position: absolute;
  bottom: 12px;
  right: 12px;
  max-width: 40px;
  max-height: 40px;
  object-fit: contain;
  pointer-events: none;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  z-index: 1;
`

interface ImageWrapper {
    imgURL: string;
    isLiked?: boolean;
    isChanged?: boolean;
    thumbnailURL?: string;
    onClick: () => void;
    isImagesSelected: boolean;
    onViewFullScreen?: () => void;
    activateWatermark?: boolean;
    watermarkUrl?: string;
}

const ImageWithSkeleton: React.FC<ImageWrapper> = ({ 
    imgURL, 
    isLiked = false, 
    thumbnailURL, 
    isImagesSelected, 
    onClick, 
    onViewFullScreen,
    activateWatermark,
    watermarkUrl
}) => {

    const [loaded, setLoaded] = useState(false);
    const [url, setUrl] = useState<string>()
    const imgRef = useRef<HTMLImageElement | null>(null);
    const [isFullImage, setIsFullImage] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (url !== imgURL)
                        setUrl(imgURL)
                }
            });
        });

        if (imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => {
            if (observer && imgRef.current) {
                observer.unobserve(imgRef.current);
            }

        };
    }, [imgURL]);
    const handleImageLoaded = () => {
        setLoaded(true);
    };
    useEffect(() => {
        if (thumbnailURL)
            setUrl(thumbnailURL)
    }, [thumbnailURL])

    const handleClick = () => {
        if (isImagesSelected) {
            onClick()
        } else if (onViewFullScreen) {
            onViewFullScreen()
        } else {
            setIsFullImage(true);
        }
    }
    return (
        <Fragment >
            <WraperDiv onClick={() => handleClick()}>

                {isFullImage && (
                    <SingleImageModal 
                        imageUrl={imgURL} 
                        thumbnailUrl={thumbnailURL} 
                        onClose={() => setIsFullImage(false)} 
                        activateWatermark={activateWatermark}
                        watermarkUrl={watermarkUrl}
                    />
                )}
                <PreviewImage
                    src={!loaded ? previewImage : url}
                    alt="Preview Image"
                    loading='lazy'
                    ref={imgRef}
                    onError={() => setUrl(thumbnailURL)}
                    onLoad={() => handleImageLoaded()}
                />
                {activateWatermark && watermarkUrl && (
                    <WatermarkOverlay
                        src={watermarkUrl}
                        alt="Watermark"
                    />
                )}
            </WraperDiv>


        </Fragment>
    );
};

export default ImageWithSkeleton;
